<template>
    <div>
        <transition name="fade">
            <div v-if="deleteFolderModal && permissions.length && permissions.includes('delete_dam')" class="modal-wrapper">
                <div class="modal-bg" @click="deleteFolderModal = false"></div>
                <div class="d-flex flex-column modal-inner p-4">
                    <div class="row mx-4 pb-1">
                        <p class="font-weight-bold">
                            Are you sure you want to delete this folder?
                        </p>
                    </div>
                    <div class="row mx-4 my-0 pb-0">
                        <div class="col-md-6 d-flex align-items-center">
                            <button class="btn my-2 btn-outline-primary" @click="deleteFolderModal = false">
                                Cancel
                            </button>
                            <button class="btn ml-2 btn-danger" @click="confirmDeleteFolder">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="d-flex flex-column mb-4">
            <h3 v-text="root ? 'Root Folder' : editableFolderProperties.name">
                {{ editableFolderProperties.name }}
            </h3>
            <div v-if="!root" class="row pb-0 mt-2">
                <div class="col-md-12">
                    <div class="py-4 col-md-12 folder-info-panel">
                      <div class="row col-md-12">
                        <div class="col-md-6">
                          <div v-if="currentFolder.parent_id != null" class="mt-2">
                              Child of 
                              <a :href="'/assets/'">
                                  <strong>
                                    Root
                                  </strong>
                              </a> > 
                              <a :href="'/assets/folder/' + currentFolder.parent_id">
                                  <strong>
                                    {{ currentFolder.parent_name }}
                                  </strong>
                              </a>
                          </div>
                          <div v-else class="mt-2">
                              Child of <a :href="'/assets/'"><strong> Root</strong></a>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <span>
                            Size
                          </span>
                          <span>
                            <strong>{{ currentFolder.size_readable }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-0 col-md-12">
                        <div class="col-md-6">
                          <span>
                            Created
                          </span>
                          <span>
                            <strong>{{ currentFolder.created_at }}</strong>
                          </span>
                        </div>
                        <div class="col-md-6">
                          <span>
                            Last Updated
                          </span>
                          <span>
                            <strong>{{ currentFolder.updated_at }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="row col-md-12 mt-0">
                        <div class="col-md-6 d-flex flex-column">
                          <label for="" class="font-weight-bold">
                            Name
                          </label>
                          <div>
                            <input type="text" class="form-control" name="" v-model="editableFolderProperties.name" id="">
                          </div>
                        </div>
                        <div class="col-md-6 d-flex flex-column justify-content-end">
                          <label for="" class="font-weight-bold">
                            Parent Folder
                          </label>
                          <div>
                            <select-folder
                                @selection="handleFolderSelection"
                                :current="folder.id"
                                :selected="folder.parent_id == null ? 0 : folder.parent_id"
                            ></select-folder>
                          </div>
                        </div>
                      </div>
                      <div class="row col-md-12 pb-0 mt-0">
                        <div class="col-md-6">
                          <button class="btn btn-primary" @click="handleUpdateFolder">Save</button>
                          <button class="btn btn-danger ml-2" v-if="permissions.length && permissions.includes('delete_dam')" @click="deleteFolderModal = true">
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <alerts :status="alert" v-model="alert"></alerts>
        <dam-folder-list 
            :current-folder="currentFolder" 
            :root="root"
            :permissions="permissions"
            @alert="handleAlert"
        >
        </dam-folder-list>
        <dam-asset-list 
            :current-folder="currentFolder"
            :root="root"
            :permissions="permissions"
            :features="features"
            class="mt-5"
            @alert="handleAlert"
        >
        </dam-asset-list>
    </div>
</template>

<script>
import axios from 'axios';
import FolderList from "./folder-list.vue";
import AssetList from "./asset-list.vue";
import SelectFolder from "./select-folder.vue";
import ProductAlerts from '../products/product-details-alerts.vue';

const base_url = window.location.protocol + "//" + window.location.host;


export default {
  name: "dam-folder",
  components: {
    "dam-folder-list": FolderList,
    "dam-asset-list": AssetList,
    "alerts": ProductAlerts,
    "select-folder": SelectFolder,
  },
  props: {
    root: {
        required: false,
        type: [Boolean, String]
    },
    folder: {
        required: false,
        type: [Object, String]
    },
  },
  data() {
    return {
      payload: {
          assetFolders: [],
          assets: []
      },
      editableFolderProperties: {
        name: '',
        parentId: 0
      },
      deleteFolderModal: false,
      alert: {
          message: "",
          status: "alert-success",
          timeOut: 15000,
      }
    };
  },
  mounted() {
      if (!this.root) {
        this.editableFolderProperties.name = this.folder.name;
        this.editableFolderProperties.parentId = this.folder.parent_id;
      }
  },
  computed: {
    currentFolder() {
      return this.folder ? this.folder : 'Root';
    },
    title() {
      return this.root ? 'Root Folder' : this.currentFolder.name;
    },
    permissions() {     
      return this.$parent.enabledPermissions ? this.$parent.enabledPermissions : [];
    },
    features() {     
      return this.$parent.enabledFeatures ? this.$parent.enabledFeatures : [];
    }
  },
  methods: {
    handleAlert(value) {
      if (Array.isArray(value.message)) {
        value.message = value.message[0];
      }

      this.alert.message = value.message;
      this.alert.status = value.status;
    },
    handleFolderSelection(value) {
        this.editableFolderProperties.parentId = value;
    },
    confirmDeleteFolder() {
      axios.delete(base_url + `/pimapi/assets/folder/${this.folder.id}`)
        .then(function (response) {
          this.deleteFolderModal = false;
          
          let alert = {
            message: 'Success, folder deleted.',
            status: 'alert-success'
          }

          this.handleAlert(alert);
          setTimeout(function() {
            window.location.href =  base_url + '/assets';  
          }, 2500);
        }.bind(this))
        .catch(function (error) {
          console.log(error);
          this.deleteFolderModal = false;

          let alert = {
            message: error.response.data.message ? error.response.data.message : 'Error deleting folder, please try again later.',
            status: 'alert-danger'
          }

          this.handleAlert(alert);
        }.bind(this));
    },
    handleUpdateFolder() {
      let payload = {};

      if (this.editableFolderProperties.name) {
        payload.name = this.editableFolderProperties.name;
      }

      if (this.editableFolderProperties.parentId !== null) {
        payload.parentId = this.editableFolderProperties.parentId;  
      }
      

      axios.put(base_url + `/pimapi/assets/folder/${this.folder.id}`, payload)
        .then(function (response) {
          let alert = {
            message: 'Success, folder updated.',
            status: 'alert-success'
          }
          this.handleAlert(alert);
        }.bind(this))
        .catch(function (error) {
          console.log(error);
          let alert = {
            message: error.response.data.message ? error.response.data.message : 'Error updating folder, please try again later.',
            status: 'alert-danger'
          }
          
          this.handleAlert(alert);
        }.bind(this));
      }
    },
};
</script>
<style lang="scss" scoped>
  ::v-deep .table-minimal {
    thead {
      tr {
        th {
          font-size: 13px;
          color: #434343;
          text-align: left;
          font-weight: 800;
          padding-top: 15px;
          padding-bottom: 15px;

          &:first-of-type {
            border-left: 1px solid #dee0e1;
          }
          &:last-of-type {
            border-right: 1px solid #dee0e1;
          }
        }
      }
    }

    tr {
      td {
        border-top: 1px solid #dee0e1;
        font-size: 12px;
        color: #676767;
        text-align: left;
        font-weight: 800;
        padding: 20px 20px;
      }
      &:last-child {
        td {
          border-bottom: 1px solid #dee0e1;
        }
      }
    }
  }

  ::v-deep .modal-wrapper {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .modal-bg {
      background: rgba(255,255,255,0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 99991;
    }

    .modal-inner {
      border: 1px solid #dedede;
      z-index: 99992;
      position: absolute;
      background: white;
    }
  }

  ::v-deep .dam-search {
    min-width: 16rem;
  }

  .folder-info-panel {
    border: 1px solid #dedede;
    background: white;
    border-radius: 2px;

    input {
      min-width: 18rem;
      max-width: 24rem;
    }
  }
  
</style>
